$('.search--textbox').keypress(function (e) {
    var str = $('.search--textbox').val();
    var domain = "https://www.cabinetstogo.com";
    var url = domain + "/pages/search-results?q=" + str;
    if (e.keyCode == 13) {
        location.href = url;
    }
});